import classnames from 'classnames';
import './styles/ProductSplash.scss';

export type TProductSplash = {
    label: string;
    color?: string;
    backgroundColor?: string;
};

export type TProductSplashProps = TProductSplash & {
    className?: string;
};

function ProductSplash({
    label = '',
    color = '',
    backgroundColor = '',
    className = '',
}: TProductSplashProps) {
    return (
        <span
            className={classnames('product-splash', className)}
            style={{
                color,
                backgroundColor,
            }}
        >
            {label}
        </span>
    );
}

export default ProductSplash;
